module.exports = __webpack_public_path__ + "img/softinya-7.7899d572.png";